export const BaseDataTableInjectionKey = 'base-data-table'
export const BaseDataTableTableInjectionKey = 'base-data-table-table'
